import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  padding: 10px;
  background-color: #fff;
  cursor: ${(props) => (props.isAnalitycsPage === true ? "unset" : "grab")};
  overflow: hidden;
  box-shadow: ${(props) =>
    props.boxShadow === true ? "0 0 10px rgb(0 0 0 / 0.2)" : "unset"};
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:active {
    cursor: grabbing;
  }
  &.draggingActive {
    box-shadow: 0 11px 15px -7px rgba(51, 61, 78, 0.2),
      0 9px 46px 8px rgba(51, 61, 78, 0.12),
      0 24px 38px 3px rgba(51, 61, 78, 0.14);
  }
  .resize-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    cursor: se-resize;
    svg {
      width: 100%;
      height: 100%;
    }
  }

  &.Desacados {
    table {
      width: 100%;
      height: 100%;
      tr {
        display: flex;
        justify-content: space-between;
        select {
          background: transparent;
          border: none;
        }
        td {
          border: 1px solid lightgray;
          width: 50%;
        }
        &.header {
          background: #d1d3d6;
        }
      }
      tbody {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        flex-wrap: wrap;
        height: 100%;
        tr {
          flex: 1;
        }
      }
    }
  }
  &.Table {
    padding: 0;
    tbody table {
      border-spacing: 0;
      .header {
        background: #d1d3d6;
        td {
          background: #d1d3d6;
        }
      }
    }
  }
  &.Comparativas table {
    width: 100%;
    height: 100%;
  }
  .listTool[contenteditable],
  .noteTool[contenteditable] {
    outline: 0px solid transparent;
    cursor: text;
    text-align: left;
  }
  &.Nota p,
  &.Tabla td {
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
  &[id^="Title"],
  &[id^="Note"],
  &[id^="Link"],
  &[id^="Table"] {
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
`;
